export default __webpack_public_path__ + "static/media/group-31.b2afe954.png";